import { Component, DestroyRef, inject, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CoreModule } from 'app/modules/core.module';
import { ModalBankComponent } from '@components/managements/banks/modal-banks/modal-bank.component';
import { PanelComponent } from '@components/core-template/panel/panel.component';
import { CampusService } from '@services/campus.service';
import { EditEntityComponent } from './edit-entity/edit-entity.component';
import { NumberPipe } from 'app/pipes/number.pipe';
import { EntityService } from '@services/entity.service';

@Component({
  selector: 'app-offices',
  standalone: true,
  imports: [EditEntityComponent, NumberPipe, PanelComponent, CoreModule],
  providers: [CampusService, EntityService],
  templateUrl: './entities.component.html',
  styleUrls: ['./entities.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EntityComponent implements OnInit {

  private _entityService = inject(EntityService)
  private fb = inject(FormBuilder)
  private destroyRef = inject(DestroyRef)
  private cdr = inject(ChangeDetectorRef)

  protected listEntities: any
  protected editOffice: any
  protected editNew = false
  protected permissions: any

  public officeForm: any


  ngOnInit(): void {
    this.officeForm = this.fb.group({
      name: [null, Validators.required],
      rut: [null, [Validators.required, Validators.pattern('^[0-9,$]*$')]],
      dv: [null, [Validators.required, Validators.maxLength(1)]],
      enabled: [true]
    })
    this.getEntities()
  }

  getEntities() {
    this._entityService.getAll().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      this.listEntities = res
      this.cdr.markForCheck()
    })
  }

  refreshData(refresh: any) {
    if (refresh) this.getEntities()
    this.editNew = false
    this.editOffice = null
  }


}
